'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

require('../css/cupoymd.css');

var _HighlightPackage = require('./commons/HighlightPackage');

var _HighlightPackage2 = _interopRequireDefault(_HighlightPackage);

var _codemirrorutil = require('../util/codemirrorutil');

var _codemirrorutil2 = _interopRequireDefault(_codemirrorutil);

var _CupoyMDHtmlParser = require('../class/CupoyMDHtmlParser');

var _CupoyMDHtmlParser2 = _interopRequireDefault(_CupoyMDHtmlParser);

var _FullImageModal = require('./modals/FullImageModal');

var _FullImageModal2 = _interopRequireDefault(_FullImageModal);

var _formatutil = require('../util/formatutil');

var _formatutil2 = _interopRequireDefault(_formatutil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*=====================================
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   Preview Content
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   Author: Gray
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   CreateTime: 2019 / 12 / 27
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               =====================================*/

/*--------------------------
    Import
--------------------------*/


/*--------------------------
    Variable
--------------------------*/
var checkIsSupportCode = _codemirrorutil2.default.checkIsSupportCode;
var formatTextToLatexHtml = _formatutil2.default.formatTextToLatexHtml,
    formatYTLinkToHtml = _formatutil2.default.formatYTLinkToHtml,
    formatFontStyleToHtml = _formatutil2.default.formatFontStyleToHtml,
    isMediumFile = _formatutil2.default.isMediumFile,
    formatMediumFileToHtml = _formatutil2.default.formatMediumFileToHtml;

/*--------------------------
    Main Component
--------------------------*/

var PreviewContent = function (_Component) {
    _inherits(PreviewContent, _Component);

    // ------------------------------
    // constructor
    // ------------------------------
    function PreviewContent(props) {
        _classCallCheck(this, PreviewContent);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            html: '',
            isOpenFullImageModal: false,
            fullImages: [],
            fullImageCurrentIndex: 0
        };

        _this.parser = undefined;
        _this.mdContainerRef = undefined;

        _this.setMDContainerRef = _this.setMDContainerRef.bind(_this);
        _this.closeFullImageModal = _this.closeFullImageModal.bind(_this);
        _this.handlePlayImageBlock = _this.handlePlayImageBlock.bind(_this);
        return _this;
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------


    PreviewContent.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var _convertMDHTML = this.convertMDHTML(),
            mdHtml = _convertMDHTML.mdHtml,
            scriptList = _convertMDHTML.scriptList;

        this.setState({
            html: mdHtml
        }, function () {
            _this2.runInnerScripts(scriptList);
        });
    };

    // ------------------------------
    // componentDidUpdate
    // ------------------------------


    PreviewContent.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this3 = this;

        var mdcontent = this.props.mdcontent;


        if (prevProps.mdcontent !== mdcontent) {

            this.parser = undefined;

            var _convertMDHTML2 = this.convertMDHTML(),
                mdHtml = _convertMDHTML2.mdHtml,
                scriptList = _convertMDHTML2.scriptList;

            this.setState({
                html: mdHtml
            }, function () {
                _this3.runInnerScripts(scriptList);
            });
        }
    };

    // ------------------------------
    // componentWillUnmount
    // ------------------------------


    PreviewContent.prototype.componentWillUnmount = function componentWillUnmount() {

        if (this.mdContainerRef) {
            this.mdContainerRef.removeEventListener('cm_playImageBlock', this.handlePlayImageBlock);
        }
    };

    // ------------------------------
    // convertMDHTML
    // ------------------------------


    PreviewContent.prototype.convertMDHTML = function convertMDHTML() {

        if (this.parser) {
            return this.parser.getResult().outerHTML;
        }

        var _props = this.props,
            mdcontent = _props.mdcontent,
            defaultFontSize = _props.defaultFontSize,
            defaultLineHeight = _props.defaultLineHeight,
            defaultFontColor = _props.defaultFontColor,
            imageNeedSSL = _props.imageNeedSSL;


        var mdHtml = '';
        var scriptList = undefined;

        if (mdcontent) {

            var renderer = new _marked2.default.Renderer();
            var tokenizer = new _marked2.default.Tokenizer();

            renderer.link = function (href, title, text) {
                var link = _marked2.default.Renderer.prototype.link.call(this, href, title, text);
                return link.replace("<a", "<a target='_blank' ");
            };

            // 因為影片類型的檔案跟圖片類型的format方式相同，所以必須查看檔案名稱或是副黨名是否為影片格式，並且回傳可以播放的HTML樣式
            renderer.image = function (href, title, text) {

                if (isMediumFile(href, title, text)) {
                    return formatMediumFileToHtml(href, title, text);
                } else {
                    return _marked2.default.Renderer.prototype.image.call(this, href, title, text);
                }
            };

            // 數學式必須在 markdown 轉換前先轉換，不然會大亂
            var formatContent = formatTextToLatexHtml(mdcontent);
            // yt iframe 必須在 markdown 轉換前先轉換，不然會大亂
            formatContent = formatYTLinkToHtml(formatContent);

            // console.log("formatContent = " + formatContent);

            var preview = (0, _marked2.default)(formatContent, {
                breaks: true,
                gfm: true,
                renderer: renderer,
                tokenizer: tokenizer,
                highlight: function highlight(text, lang, callback) {

                    if (!lang || !checkIsSupportCode(lang)) {
                        return _HighlightPackage2.default.highlightAuto(text).value;
                    }
                    return _HighlightPackage2.default.highlight(lang, text).value;
                }
            });

            // console.log("preview = " + preview);

            this.parser = new _CupoyMDHtmlParser2.default(preview, {
                defaultFontSize: defaultFontSize,
                defaultLineHeight: defaultLineHeight,
                defaultFontColor: defaultFontColor,
                handlePlayImageBlock: true,
                imageNeedSSL: imageNeedSSL
            });

            mdHtml = this.parser.getResult().outerHTML;

            // format font style (一定要在format成HTML後面之後再處理，不然被HTML標籤包覆的markdown語法都會失效，這邊是使用暴力取代法，所以可能會造成部分內容有誤)
            mdHtml = formatFontStyleToHtml(mdHtml);

            scriptList = this.parser.getResultScripts();
        }

        return {
            mdHtml: mdHtml,
            scriptList: scriptList
        };
    };

    // ------------------------------
    // scriptList
    // ------------------------------


    PreviewContent.prototype.runInnerScripts = function runInnerScripts(scriptList) {

        if (!Array.isArray(scriptList) || scriptList.length === 0) {
            return;
        }

        setTimeout(function () {
            for (var i = 0; i < scriptList.length; i++) {
                var executeScript = new Function(scriptList[i]);
                executeScript();
            }
        }, 500);
    };

    // ------------------------------
    // setMDContainerRef
    // ------------------------------


    PreviewContent.prototype.setMDContainerRef = function setMDContainerRef(ref) {

        if (ref === null || this.mdContainerRef === ref) {
            return;
        }

        this.mdContainerRef = ref;
        this.mdContainerRef.addEventListener('md_playImageBlock', this.handlePlayImageBlock);
    };

    // ------------------------------
    // closeFullImageModal
    // ------------------------------


    PreviewContent.prototype.closeFullImageModal = function closeFullImageModal() {

        this.setState({
            isOpenFullImageModal: false
        });
    };

    // ------------------------------
    // handlePlayImageBlock
    // ------------------------------


    PreviewContent.prototype.handlePlayImageBlock = function handlePlayImageBlock(event) {

        event.preventDefault();
        event.stopImmediatePropagation();

        var _props2 = this.props,
            imageNeedSSL = _props2.imageNeedSSL,
            handlePlayImageBlock = _props2.handlePlayImageBlock;
        var _event$detail = event.detail,
            imageSrc = _event$detail.imageSrc,
            mouseEvent = _event$detail.mouseEvent;


        if (imageSrc.indexOf('blob:') !== 0 && !imageNeedSSL) {
            imageSrc = imageSrc.replace('http://', '//').replace('https://', '//');
        }

        if (handlePlayImageBlock) {
            handlePlayImageBlock({
                imageSrc: imageSrc
            });
            return;
        }

        this.setState({
            isOpenFullImageModal: true,
            fullImages: [imageSrc],
            fullImageCurrentIndex: 0
        });
    };

    // ------------------------------
    // render
    // ------------------------------


    PreviewContent.prototype.render = function render() {
        var _state = this.state,
            html = _state.html,
            isOpenFullImageModal = _state.isOpenFullImageModal,
            fullImages = _state.fullImages,
            fullImageCurrentIndex = _state.fullImageCurrentIndex;


        if (!html) {
            return _react2.default.createElement('div', null);
        }

        return _react2.default.createElement(
            'div',
            { className: 'cupoymd-content-style', ref: this.setMDContainerRef },
            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: html } }),
            isOpenFullImageModal ? _react2.default.createElement(_FullImageModal2.default, {
                closeCallback: this.closeFullImageModal,
                images: fullImages,
                currentIdx: fullImageCurrentIndex
            }) : null
        );
    };

    return PreviewContent;
}(_react.Component);

/*--------------------------
    Props
--------------------------*/


PreviewContent.propTypes = process.env.NODE_ENV !== "production" ? {
    defaultFontSize: _propTypes2.default.number,
    defaultLineHeight: _propTypes2.default.number,
    defaultFontColor: _propTypes2.default.string,
    imageNeedSSL: _propTypes2.default.bool,
    mdcontent: _propTypes2.default.string,
    handlePlayImageBlock: _propTypes2.default.func
} : {};

PreviewContent.defaultProps = {
    defaultFontSize: 16,
    defaultLineHeight: 1.75,
    defaultFontColor: '#333333',
    imageNeedSSL: false,
    mdcontent: ''
};

/*--------------------------
    Export
--------------------------*/
exports.default = PreviewContent;
module.exports = exports['default'];